import { CampaignsPageSections } from 'common/views/sectionTypes';
import gsap from 'gsap';
import { CreateExitAnimation } from './PageHelpers';
import { Breakpoints } from 'common/views/appBreakpoints';


// Create animations between sections
if (Breakpoints.isDesktop) {
    // Get sections
    const CampaignsSection = document.querySelector('.hero-section-campaigns__content') as HTMLElement;
    const WorksSection = document.getElementById(CampaignsPageSections.Works);
    const PowerfulSection = document.getElementById(CampaignsPageSections.Powerful);
    const JoinSection = document.getElementById(CampaignsPageSections.Join);
    const NetworkSection = document.getElementById(CampaignsPageSections.Network);

    // Create custom exit animations if necessary
    const exitAnimationFromCampaignsToWorks = gsap.timeline()
        .fromTo(CampaignsSection, { x: 0 }, { x: 140, duration: 1 });

    // Create animations between sections
    CreateExitAnimation(CampaignsSection, WorksSection, exitAnimationFromCampaignsToWorks);
    CreateExitAnimation(WorksSection, PowerfulSection);
    CreateExitAnimation(PowerfulSection, NetworkSection);
    CreateExitAnimation(NetworkSection, JoinSection);
}
